
if (!customElements.get('horizontal-slider')) {
  customElements.define(
    'horizontal-slider',
    class HorizontalSlider extends HTMLElement {
      constructor() {
        super();

        this.slides = null;
        this.initialScrollY = null;
        this.lastScrollTop = null;
        this.maxScrollLeft = null;
        this.tablet = null;
        this.scrollDivider = null;
      }

      connectedCallback() {
        this.slides = this.querySelectorAll('.circle-slide');
        this.maxScrollLeft = this.scrollWidth - this.clientWidth;
        this.tablet = window.matchMedia("(max-width: 749px)").matches;

        this.tablet ? this.scrollDivider = 30 : this.scrollDivider = 15;

        window.addEventListener('scroll', event => this.scrollHorizontalSlider(event));

        this.addEventListener('scroll', () => {
          this.slides.forEach(slide => {
            this.isElementHorizontallyCentered(slide) 
            ? slide.classList.add('active') 
            : slide.classList.remove('active');
          });
        });
      }

      sliderIsInViewport() {
        const rect = this.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
          );
      }

      scrollHorizontalSlider(e) {
        const isVisible = this.sliderIsInViewport();
        const currentScrollY = window.scrollY;
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (isVisible)  {
          if (!this.initialScrollY) this.initialScrollY = currentScrollY;
          
          if (scrollTop > this.lastScrollTop){
            this.scrollLeft += (currentScrollY - this.initialScrollY ) / this.scrollDivider;
          }else {
            this.scrollLeft -= (currentScrollY - this.initialScrollY ) / this.scrollDivider;
          }

          this.lastScrollTop = currentScrollY;

        }
      }

      isElementHorizontallyCentered(element) {
        const viewportWidth = window.innerWidth;
        const rect = element.getBoundingClientRect();
        const elementCenter = rect.left + rect.width / 2;
        const viewportCenter = viewportWidth / 2;
        const threshold = element.offsetWidth; 
    
        return Math.abs(elementCenter - viewportCenter) <= threshold;
      }
    }
  );
}
